(() => {
  const configNode = document.getElementById('vl-order-attribution-config');
  if (!configNode) return;

  const config = JSON.parse(configNode.textContent);
  const storageKey = 'vl_order_attribution_v1';
  const clickIds = new Set([
    'fbclid', 'gclid', 'gbraid', 'wbraid', 'ttclid', 'msclkid',
    'twclid', 'sccid', 'irclickid', 'campaign_id', 'adset_id', 'ad_id'
  ]);
  const isAttributionParam = key => /^utm_/i.test(key) || clickIds.has(key.toLowerCase());
  const currentUrl = new URL(window.location.href);

  let stored = {};
  try {
    stored = JSON.parse(sessionStorage.getItem(storageKey) || '{}');
  } catch (_) {}

  const captured = {};
  currentUrl.searchParams.forEach((value, key) => {
    if (isAttributionParam(key) && value) captured[key] = value;
  });
  const attribution = {...stored, ...captured};

  try {
    sessionStorage.setItem(storageKey, JSON.stringify(attribution));
  } catch (_) {}

  // EasySell reads the current URL plus Meta's first-party _fbc/_fbp cookies
  // when it creates the order. Restore missing ad parameters before the app
  // initializes so source_url, UTMs and click IDs remain attached to the order.
  if (config.orderPage) {
    let changed = false;
    Object.entries(attribution).forEach(([key, value]) => {
      if (!currentUrl.searchParams.has(key) && value) {
        currentUrl.searchParams.set(key, value);
        changed = true;
      }
    });
    if (changed) window.history.replaceState(null, '', currentUrl.href);
  }

  const decorateOrderLinks = () => {
    document.querySelectorAll('[data-vl-order-link]').forEach(link => {
      const destination = new URL(link.href, window.location.href);
      Object.entries(attribution).forEach(([key, value]) => {
        if (value) destination.searchParams.set(key, value);
      });
      link.href = destination.href;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', decorateOrderLinks, {once:true});
  } else {
    decorateOrderLinks();
  }
})();
